/**
 * 个人主页侧边导航菜单
 */

import React from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  useTheme,
} from '@mui/material';
import {
  Person as PersonIcon,
  Star as StarIcon,
  Wallet as WalletIcon,
  BarChart as BarChartIcon,
  Favorite as FavoriteIcon,
  History as HistoryIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

const menuItems = [
  {
    id: 'basic',
    label: '基本资料',
    icon: PersonIcon,
  },
  {
    id: 'membership',
    label: '会员特权',
    icon: StarIcon,
  },
  {
    id: 'wallet',
    label: '积分钱包',
    icon: WalletIcon,
  },
  {
    id: 'stats',
    label: '观看统计',
    icon: BarChartIcon,
  },
  {
    id: 'favorites',
    label: '我的收藏',
    icon: FavoriteIcon,
  },
  {
    id: 'history',
    label: '观看历史',
    icon: HistoryIcon,
  },
  {
    id: 'settings',
    label: '账号设置',
    icon: SettingsIcon,
  },
];

const ProfileSidebar = ({ activeTab, onTabChange, user }) => {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <List sx={{ py: 1 }}>
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;

          return (
            <ListItem
              key={item.id}
              button
              onClick={() => onTabChange(item.id)}
              sx={{
                mx: 1,
                my: 0.3,
                borderRadius: 1.5,
                backgroundColor: isActive
                  ? theme.palette.primary.main
                  : 'transparent',
                color: isActive
                  ? 'white'
                  : theme.palette.text.primary,
                '&:hover': {
                  backgroundColor: isActive
                    ? theme.palette.primary.dark
                    : theme.palette.action.hover,
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 40,
                  color: isActive
                    ? 'white'
                    : theme.palette.text.secondary,
                }}
              >
                <Icon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: isActive ? 600 : 400,
                }}
              />
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
};

export default ProfileSidebar;
